// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"624":"325c7c45","925":"ae98f390"}[chunkId] + ".chunk.css";
};